import React, { PureComponent } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'pui-react-grids'
import {
  getOtherUserInfo,
  loadOtherUserCounts,
  unloadOtherUserInfo,
} from '../../actions'
import UserOwnedItems from './UserOwnedItems'
import UserWantedItems from './UserWantedItems'
import UserItemsICanGet from './UserItemsICanGet'
import Spinner from '../../common/Spinner'
import ErrorPage from '../../common/ErrorPage'
import UserSideMenu from '../../common/UserSideMenu'
import MediaQuery from 'react-responsive'
import breakpoints from '../../styles/breakpoints'
import UserBottomBar from '../../common/UserBottomBar'
import withTopBar from '../../common/TopBar/withTopBar'

class User extends PureComponent {
  componentDidMount() {
    this.props.getOtherUserInfo(this.props.match.params.username)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.username !== nextProps.match.params.username) {
      this.props.unloadOtherUserInfo()
      this.props.getOtherUserInfo(nextProps.match.params.username)
    }

    // Ok, got user or has changed :P
    if (nextProps.userInfo && !this.props.userInfo) {
      this.props.loadOtherUserCounts(nextProps.userInfo.id)
    }

    if (nextProps.userInfo !== this.props.userInfo && nextProps.userInfo) {
      this.props.topBarSetTitle(nextProps.userInfo.username)
    }
  }

  componentWillUnmount() {
    this.props.unloadOtherUserInfo()
  }

  render() {
    const { loading, userInfo, counts, error, match } = this.props

    return (
      <div>

        {loading && <Spinner centered />}

        {error && <ErrorPage error={error} />}

        {userInfo &&
          <div className="padding">
            <Row>
              <Col lg={5}>
                <MediaQuery minWidth={breakpoints.md}>
                  <UserSideMenu user={userInfo} counts={counts} />
                </MediaQuery>
              </Col>

              <Col md={24} lg={19}>
                <Switch>
                  <Route
                    path={`${match.url}/items/owned`}
                    component={UserOwnedItems}
                  />
                  <Route
                    path={`${match.url}/items/wanted`}
                    component={UserWantedItems}
                  />
                  <Route
                    path={`${match.url}/items/can-get`}
                    component={UserItemsICanGet}
                  />
                  <Redirect from="" to={`${match.url}/items/owned`} />
                </Switch>
              </Col>
            </Row>

          </div>}
        <MediaQuery maxWidth={breakpoints.md}>
          {userInfo && <UserBottomBar otherUser={userInfo} />}
        </MediaQuery>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  userInfo: state.otherUser.info.data,
  // TODO: Bad path find better names :P
  counts: state.otherUser.counts.counts,
  loading: state.otherUser.info.loading,
  error: state.otherUser.info.error,
})

export default withTopBar({
  toolbar: 'UserToolbar',
})(
  connect(mapStateToProps, {
    getOtherUserInfo,
    loadOtherUserCounts,
    unloadOtherUserInfo,
  })(User)
)



// WEBPACK FOOTER //
// ./src/pages/User/User.js